import { Collection } from 'modules/core/lib/mobx-rest'

import TaskType from 'modules/bookkeepers/store/models/TaskType'

class TaskTypes extends Collection<TaskType> {
  get cacheKey(): string {
    return 'taskTypes'
  }

  model() {
    return TaskType
  }
}

const singleton: TaskTypes = new TaskTypes()

export { TaskTypes }

export default singleton
